import { useEffect, useState } from "react";

const DAY_MS = 86_400_000;

/** Ticks once a second, only while `active`. */
const useNow = (active: boolean) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [active]);
  return now;
};

/** Live HH : MM : SS countdown for an upcoming match that starts within 24 hours. Null otherwise. */
export const useCountdown = (start: Date | null, isUpcoming: boolean) => {
  const upcoming = isUpcoming && !!start;
  const within = upcoming && start!.getTime() - Date.now() < DAY_MS;
  const now = useNow(within);
  if (!upcoming || !start) return null;
  const left = start.getTime() - now;
  if (left >= DAY_MS) return null;
  if (left <= 0) return left > -3 * 3_600_000 ? { over: true as const } : null; // long overdue: fall back to the plain status text
  const t = Math.floor(left / 1000);
  return { over: false as const, h: Math.floor(t / 3600), m: Math.floor((t % 3600) / 60), s: t % 60, soon: left < 3_600_000 };
};
export type Countdown = NonNullable<ReturnType<typeof useCountdown>>;
export const pad2 = (n: number) => String(n).padStart(2, "0");
